export const getFormattedCurrency = (currency: string): string =>
  ({
    BRL: 'R$',
    USD: '$',
  }[currency] || 'R$');
